import React from 'react';
import {
  Box,
  Grid,
  List,
  ListItem,
  Stack,
  Typography
} from '@mui/material';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import TableChartIcon from '@mui/icons-material/TableChart';
import { PageContainer, Section, StatGrid } from '../components/AdminContentWrapper';

const SemanticDimensions = () => {
  return (
    <PageContainer
      title="Dimensiones"
      description="Establece jerarquías, atributos de clasificación y catálogos maestros para segmentar tus tableros."
    >
      <StatGrid
        items={[
          { label: 'Dimensiones activas', value: '24', trend: '+4 nuevas jerarquías' },
          { label: 'Valores únicos gobernados', value: '3.4K', trend: '+320 valores certificados' },
          { label: 'Tablas de referencia', value: '56', trend: 'Sin cambios críticos' },
          { label: 'Sincronizaciones diarias', value: '96', trend: '+18 ejecuciones' }
        ]}
      />

      <Section
        title="Catálogos principales"
        subtitle="Mantén la consistencia entre catálogos y métricas derivadas"
      >
        <Grid container spacing={3}>
          {[
            {
              name: 'Calendario corporativo',
              detail: 'Años fiscales, periodos contables y feriados regionales',
              update: 'Actualizado hace 1 día',
              icon: <TableChartIcon sx={{ color: 'var(--wb-accent)' }} />
            },
            {
              name: 'Segmentación de clientes',
              detail: 'Segmentos estratégicos, cohortes y niveles de fidelidad',
              update: 'Actualizado hace 3 días',
              icon: <ViewQuiltIcon sx={{ color: 'var(--wb-warning)' }} />
            },
            {
              name: 'Catálogo de productos',
              detail: 'Familias, subfamilias, variantes y status comercial',
              update: 'Actualizado en este sprint',
              icon: <LayersOutlinedIcon sx={{ color: 'var(--wb-x-text-f472b6, #f472b6)' }} />
            }
          ].map((catalog) => (
            <Grid item xs={12} md={4} key={catalog.name}>
              <Box
                sx={{
                  backgroundColor: 'var(--wb-bg-surface)',
                  borderRadius: 2,
                  border: '1px solid var(--wb-border-10)',
                  p: 3,
                  height: '100%'
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                  {catalog.icon}
                  <Box>
                    <Typography sx={{ color: 'var(--wb-text-title)', fontWeight: 600 }}>{catalog.name}</Typography>
                    <Typography sx={{ color: 'var(--wb-muted-75)', fontSize: '0.85rem' }}>
                      {catalog.update}
                    </Typography>
                  </Box>
                </Stack>
                <Typography sx={{ color: 'var(--wb-muted-76)' }}>{catalog.detail}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Section>

      <Section
        title="Reglas de estandarización"
        subtitle="Automatiza validaciones para mitigar discrepancias de carga"
      >
        <List>
          {[
            {
              title: 'Dimensión “Tiempo”',
              detail: 'Validación de granularidad hora/día/semana y consistencia de periodos'
            },
            {
              title: 'Dimensión “Geografía”',
              detail: 'Normalización de códigos ISO, traducciones y niveles jerárquicos'
            }
          ].map((rule) => (
            <ListItem key={rule.title} sx={{ px: 0 }}>
              <Stack spacing={1}>
                <Typography sx={{ color: 'var(--wb-text-title)', fontWeight: 600 }}>{rule.title}</Typography>
                <Typography sx={{ color: 'var(--wb-muted-76)' }}>{rule.detail}</Typography>
              </Stack>
            </ListItem>
          ))}
        </List>
      </Section>
    </PageContainer>
  );
};

export default SemanticDimensions;

